export default __webpack_public_path__ + "static/media/ankle-cover.26d5ac5d.png";